import React, { useEffect, useState } from "react";
import {useEyeconxStore} from "../../../store/eyeconxStore";
import clinicService from "../../../services/clinic.service"
import SubHeader from "../../layout/components/SubHeader";

const MyActivity = () => {
    const [data, setData] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const clinicId = useEyeconxStore(state => state.user.clinicId)

    const fetchData = async (page = 0) => {
        try {
            // Replace with your real API endpoint
            //const res = await axios.get(`/api/update-history?page=${page}&size=${pageSize}`);
            const res = await clinicService.getUpdateHistory(clinicId, pageNumber, pageSize);
            setData(res.data.content);
            setTotalPages(res.data.totalPages);
            setPageNumber(res.data.number);
            setTotalRecords(res.data.totalElements);
        } catch (err) {
            console.error("Failed to load update history", err);
        }
    };

    useEffect(() => {
        fetchData(pageNumber, pageSize);
    }, [pageNumber, pageSize]);

    const handlePrev = () => {
        if (pageNumber > 0) setPageNumber(pageNumber - 1);
    };

    const handleNext = () => {
        if (pageNumber < totalPages - 1) setPageNumber(pageNumber + 1);
    };

    const handlePageSizeChange = (e) => {
        setPageSize(Number(e.target.value));
        setPageNumber(0);
    };
    const getStatusBadge = (result) => {
        if (result === 'SUCCESS') {
            return (
                <span className="badge bg-success">
                    <i className="bi bi-check-circle-fill me-1"></i>
                    Success
                </span>
            );
        } else {
            return (
                <span className="badge bg-danger">
                    <i className="bi bi-x-circle-fill me-1"></i>
                    Failed
                </span>
            );
        }
    };

    const getPmsTypeBadge = (pmsType) => {
        return (
            <span className="p-2 rounded bg-light text-dark border">
                <i className="bi bi-laptop me-1"></i>
                {pmsType}
            </span>
        );
    };

    const formatNotes = (notes) => {
        return notes.split(', ').map((item, index) => (
            <div key={index} className="small text-muted">
                <i className="bi bi-dot me-1"></i>
                {item}
            </div>
        ));
    };

    return (
        <>
            <SubHeader title="Update History" description={"Update Data History from Practice Management System. "}/>
        <div className="card shadow-sm mt-4">


            <div className="card-body">
                {/* Top controls */}
                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <div className="d-flex align-items-center">
                        <label className="me-2 mb-0">Show</label>
                        <select
                            className="form-select w-auto"
                            value={pageSize}
                            onChange={handlePageSizeChange}
                        >
                            {[5, 10, 25, 50].map(size => (
                                <option key={size} value={size}>{size}</option>
                            ))}
                        </select>
                        <span className="ms-2">entries</span>
                    </div>
                    <div className="text-muted">
                        Total records: {totalRecords}
                    </div>
                </div>

                {/* Table */}
                <div className="table-responsive">
                    <table className="table table-bordered align-middle mb-0">
                        <thead className="bg-light">
                        <tr>
                            <th scope="col" className="ps-4 py-3">
                                <i className="bi bi-calendar me-1"></i>
                                Date & Time
                            </th>
                            <th scope="col" className="py-3">
                                <i className="bi bi-check-circle me-1"></i>
                                Status
                            </th>
                            <th scope="col" className="py-3">
                                <i className="bi bi-laptop me-1"></i>
                                PMS Type
                            </th>
                            <th scope="col" className="py-3">
                                <i className="bi bi-journal-text me-1"></i>
                                Update Details
                            </th>

                        </tr>
                        </thead>
                        <tbody>
                        {data.length > 0 ? (
                            data.map((item) => (
                                <tr key={item.id} className="border-bottom">
                                    <td className="ps-4">
                                        <div className="d-flex align-items-center">
                                            <div className="bg-primary bg-opacity-10 rounded p-2 me-3">
                                                <i className="bi bi-calendar-check text-primary"></i>
                                            </div>
                                            <div>
                                                <div className="fw-semibold">{item.createdAt}</div>
                                                <small className="text-muted">
                                                    ID: {item.id}
                                                </small>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        {getStatusBadge(item.result)}
                                    </td>
                                    <td>
                                        {getPmsTypeBadge(item.pmsType)}
                                    </td>
                                    <td>
                                        <div className="small">
                                            {formatNotes(item.notes)}
                                        </div>
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center text-muted py-3">
                                    No records found
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                {/* Bottom pagination */}
                <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                    <div className=" text-muted">
                        Showing{" "}
                        {totalRecords === 0
                            ? 0
                            : pageNumber * pageSize + 1}{" "}
                        to{" "}
                        {Math.min((pageNumber + 1) * pageSize, totalRecords)} of{" "}
                        {totalRecords} entries
                    </div>

                    <nav>
                        <ul className="pagination mb-0">
                            <li className={`page-item ${pageNumber === 0 ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setPageNumber(0)}>
                                    «
                                </button>
                            </li>
                            <li className={`page-item ${pageNumber === 0 ? "disabled" : ""}`}>
                                <button className="page-link" onClick={handlePrev}>
                                    ‹
                                </button>
                            </li>
                            <li className="page-item active">
                                <span className="page-link">{pageNumber + 1}</span>
                            </li>
                            <li
                                className={`page-item ${
                                    pageNumber >= totalPages - 1 ? "disabled" : ""
                                }`}
                            >
                                <button className="page-link" onClick={handleNext}>
                                    ›
                                </button>
                            </li>
                            <li
                                className={`page-item ${
                                    pageNumber >= totalPages - 1 ? "disabled" : ""
                                }`}
                            >
                                <button
                                    className="page-link"
                                    onClick={() => setPageNumber(totalPages - 1)}
                                >
                                    »
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
            </>
    );
};


export default MyActivity;
